"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _logger = _interopRequireDefault(require("./logger"));
var _AuthSessionCookieManager = _interopRequireDefault(require("../modules/AuthSessionCookieManager"));
const navCachedDomainsCookie = "navCachedDomains";
class NavCacheCookieManager {
  getNavCachedDomains() {
    const navCachedDomainsText = _AuthSessionCookieManager.default.get(navCachedDomainsCookie);
    if (!navCachedDomainsText) return null;
    let navCachedDomains = null;
    try {
      navCachedDomains = JSON.parse(navCachedDomainsText);
    } catch (e) {
      _logger.default.warn("The ".concat(navCachedDomainsCookie, " cookie contains invalid data"));
      return null;
    }

    // @ts-ignore
    if (!navCachedDomains || !navCachedDomains.length > 0) {
      return null;
    }
    return navCachedDomains;
  }
  addNavCacheDomain() {
    let navCachedDomains = this.getNavCachedDomains();
    const currentDomain = window.location.hostname;
    if (navCachedDomains) {
      if (navCachedDomains.includes(currentDomain)) return;
      navCachedDomains.push(currentDomain);
    } else {
      navCachedDomains = [currentDomain];
    }
    _AuthSessionCookieManager.default.set(navCachedDomainsCookie, JSON.stringify(navCachedDomains));
  }
  clearCachedDomains() {
    _AuthSessionCookieManager.default.remove(navCachedDomainsCookie);
  }
  navIsCachedForThisDomain() {
    const navCachedDomains = this.getNavCachedDomains();
    if (!navCachedDomains) return false;
    const currentDomain = window.location.hostname;
    return !!navCachedDomains.includes(currentDomain);
  }
}
const navCacheCookieManager = new NavCacheCookieManager();
var _default = exports.default = navCacheCookieManager;